import * as styles from "./InlineCode.styles";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

const InlineCode = (props: Props) => {
  return <code {...props} css={styles.inlineCode} />;
};

export { InlineCode };
